import { Injectable } from '@angular/core';
import { CoreModule } from '../core.module';

@Injectable({
	providedIn: CoreModule,
})
export class AgentService {
	constructor(
	) { }

	getBrowserInfo(): string {
		const { userAgent } = window.navigator;
		let browserName = 'Unknown';
		let browserVersion = '';

		if (userAgent.includes('Firefox')) {
			browserName = 'Mozilla Firefox';
			browserVersion = userAgent.match(/Firefox\/([\d.]+)/)?.[1] || '';
		} else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
			browserName = 'Opera';
			browserVersion = userAgent.match(/(Opera|OPR)\/([\d.]+)/)?.[2] || '';
		} else if (userAgent.includes('Trident')) {
			browserName = 'Microsoft Internet Explorer';
			browserVersion = userAgent.match(/rv:([\d.]+)/)?.[1] || '';
		} else if (userAgent.includes('Edge')) {
			browserName = 'Microsoft Edge';
			browserVersion = userAgent.match(/Edge\/([\d.]+)/)?.[1] || '';
		} else if (userAgent.includes('Chrome')) {
			browserName = 'Google Chrome';
			browserVersion = userAgent.match(/Chrome\/([\d.]+)/)?.[1] || '';
		} else if (userAgent.includes('Safari')) {
			browserName = 'Apple Safari';
			browserVersion = userAgent.match(/Version\/([\d.]+)/)?.[1] || '';
		}

		return `${browserName} ${browserVersion}`;
	}
}
